import {useEffect, useState} from "react";
import {adminTransactionService} from "../services/admin-transaction.service";

export function useTransactions(initialParams = {}) {
  const [params, setParams] = useState({page: 1, limit: 10, ...initialParams});
  const [data, setData] = useState({documents: [], pagination: {}});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    adminTransactionService
      .list(params)
      .then((res) => mounted && setData(res.data))
      .finally(() => mounted && setLoading(false));
    return () => (mounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return {data, loading, params, setParams};
}
